<template>

    <div>
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="autocompleteRequestParams.usuario"
                    :searchFields="fields.autocomplete.usuario"
                    :validations="validations.usuario"
                    text-field="cidadaoNome"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="data.model.cadastro.usuario"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="data.model.cadastro.unidadeId"
                    :validations="validations.unidade"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="isDisabled"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturas"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.cadastro.infraestruturaId"
                    :validations="validations.infraestrutura"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="data.model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Código da equipe"
                    :options="equipes"
                    textField="descricao"
                    v-model="data.model.cadastro.equipeId"
                    :validations="validations.equipe"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Ocupação"
                    :options="ocupacoes"
                    textField="codigoNome"
                    v-model="data.model.cadastro.ocupacaoId"
                    :validations="validations.ocupacao"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-col>
                    <rkm-form-date-picker
                        label="Data"
                        :max-date="data.form.dataAtual"
                        v-model="data.model.cadastro.dataUsuarioResponsavel"
                        :validations="validations.data"
                        right
                    />
                </rkm-col>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Filters
import formats from '@/filters/formats'

// Mixins
import { repository, object } from '@/mixins'

// Enums.
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'

export default {
    computed: {
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.VISITA_DOMICILIAR,
                    not_usuario_id: this.data.model.cadastro.usuarioAuxiliar && this.data.model.cadastro.usuarioAuxiliar.id
                        ? this.data.model.cadastro.usuarioAuxiliar.id
                        : null,
                },
            }
        },
        validations() {
            return {
                usuario: { required: true },
                unidade: { required: true },
                equipe: { required: true },
                ocupacao: { required: true },
                data: { required: true },            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        isDisabled() {

            return !this.data.model.cadastro.usuario
                || this.data.model.cadastro.usuario && !this.data.model.cadastro.usuario.id
        },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getUnidades() {

            this.setLoading()

            this.repositories.visitaDomiciliar.getUnidades({usuario_id: this.data.model.cadastro.usuario.id})
                .then(({ data }) => {

                    this.unidades = data

                    if (data.length === 1){

                        this.data.model.cadastro.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {

            this.setLoading()

            this.repositories.visitaDomiciliar.getInfraestruturas({
                usuario_id: this.data.model.cadastro.usuario.id,
                unidade_id: this.data.model.cadastro.unidadeId
            })
                .then(({ data }) => {

                    this.infraestruturas = data

                    if (data.length === 1) {

                        this.data.model.cadastro.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {

            this.setLoading()

            this.repositories.visitaDomiciliar.getEquipes({
                usuario_id: this.data.model.cadastro.usuario.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaId
            })
                .then(({ data }) => {

                    this.equipes = data

                    if (data.length === 1){

                        this.data.model.cadastro.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {

            this.setLoading()

            this.repositories.visitaDomiciliar.getOcupacoes({
                usuario_id: this.data.model.cadastro.usuario.id,
                infraestrutura_id: this.data.model.cadastro.infraestruturaId
            })
                .then(({ data }) => {

                    this.ocupacoes = data

                    if (data.length === 1){

                        this.data.model.cadastro.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCadastro(field) {

            if (field === 'usuario'){

                this.data.model.cadastro.unidadeId = null
                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            } else if (field === 'infraestrutura'){

                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            } else {

                this.data.model.cadastro.infraestruturaId = null
                this.data.model.cadastro.equipeId = null
                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            }
        },
        getMesesCompetencia() {
            const mesesCompetencia = [];

            for (let i = 0; i < 4; i++) {
                const mesCompetencia = moment().subtract(i, 'months').format('MM/YYYY');
                mesesCompetencia.push(mesCompetencia);
            }

            return mesesCompetencia.join(', ');
        },
    },
    data() {
        return {
            unidades: [],
            equipes: [],
            infraestruturas: [],
            ocupacoes: [],
            enums: {
                permissao
            }
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
    },
    mounted () {
        this.$nextTick(function () {

            if (this.data.model.cadastro.usuario && this.data.model.cadastro.usuario.id) {

                this.getUnidades()

                if (this.data.model.cadastro.unidadeId) {

                    this.getInfraestruturas()
                    this.getEquipes()
                    this.getOcupacoes()
                }
            }
        })
    },
    watch: {
        'data.model.cadastro.usuario': function (usuario) {

            if (usuario) {

                this.getUnidades()
            }

            this.setCadastro('usuario')
        },
        'data.model.cadastro.unidadeId': function (unidadeId) {

            if (unidadeId) {

                this.getInfraestruturas()
            }

            this.setCadastro('unidade')
        },
        'data.model.cadastro.infraestruturaId': function (infraestruturaId) {

            if (infraestruturaId) {

                this.getEquipes()
                this.getOcupacoes()
            }

            this.setCadastro('infraestrutura')
        },
        'data.model.cadastro.dataUsuarioResponsavel': function (dataUsuarioResponsavel) {

            const mesesCompetencia = this.getMesesCompetencia()

            const limite = moment(this.data.form.dataAtual, 'DD/MM/YYYY').subtract(3, 'months').format('YYYY-MM')
            const dataCadastro = moment(dataUsuarioResponsavel).format('YYYY-MM')

            if (dataCadastro < limite) {

                this.showAlert(`Este atendimento está fora do prazo de faturamento, referente às competências
                    (<strong>${mesesCompetencia}</strong>). Embora seja possível finalizá-lo, não será possível
                    incluí-lo no processo de faturamento.`, 'Atenção')
            }
        },
    }
}
</script>